import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@Services/auth.service';

export const unauthenticatedGuard: CanActivateFn = (route): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    const from = route.queryParamMap.get('from');
    if (from) {
      return router.parseUrl(from);
    }
    return router.createUrlTree(['/home']);
  }

  return true;
};
